import React, { useState, useEffect } from "react";
import { FiEye, FiTrash2 } from "react-icons/fi";

import SearchButton from "../../../components/buttons/search/search-btn";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import {
  get_resList_list,
  admin_resper_delete,
  get_vendors_list,
  admin_vendor_delete,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import moment from "moment";
import * as XLSX from "xlsx";
import { statusVendorType } from "../../../components/table/store";

const getStatusInfo = (status) => {
  const statusMap = {
    0: { label: "Pending", class: "pending", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    1: { label: "Submitted", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg> },
    2: { label: "Initial Acceptance", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> },
    3: { label: "Payment Initiated", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    4: { label: "Payment Confirmed", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
    5: { label: "Approved", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
    6: { label: "Reverted to Admin", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v4m0 4h.01"></path></svg> },
    7: { label: "Reverted to User", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v4m0 4h.01"></path></svg> },
    8: { label: "Payment Issue", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> },
  };
  return statusMap[status] || { label: "Unknown", class: "secondary", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> };
};

export default function View(props) {
  const [data, setdata] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleAdviserList = () => {
    setIsActive(true);
    get_vendors_list(adminType)
      .then((res) => {
        let tdata = res?.data || [];
        tdata.forEach((item, index) => {
          item["slno"] = index + 1;
        });
        setdata(tdata);
        setIsActive(false);
      }).catch((err) => {
        setdata([]);
        setSnackMessage(err?.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);

      })
      .finally(() => {
        setIsActive(false);
      });
  };
  const handleAddNew = (row) => {
    let path = `/resource-add`;
    props.history.push(path);
  };

  const handleView = (data) => {
    let path = `/vendor-view/${data.id}`;
    props.history.push(path);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_vendor_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleAdviserList();
    }
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleDownload = (dt) => {
    let path = `${result}${dt.brochure}`;
    window.open(path, "_blank");
  };
  const handleDownloadReceipt = (dt) => {
    let path = `${result}${dt.reciept}`;
    window.open(path, "_blank");
  };

  const handleBulkEmail = () => {
    let path = `/bulk-email-vendors`;
    props.history.push(path);
  };

  const downloadExcel = () => {
    const exportData = data.map((item) => {
      const statusObj = statusVendorType.find((s) => s.id === item.status);
      return {
        Name: item?.name ?? "",
        "Company Name": item?.company_name ?? "",
        "Application Ref No": item?.unique_application_ref_no ?? "",
        "Email": item?.email ?? "",
        "Contact Number": item?.phone ?? "",
        "Alternate Email": item?.alternate_email ?? "",
        "Alternate Phone": item?.alternate_phone ?? "",
        Address: item?.address ?? "",
        "Area Of Operation": item?.area_of_operation ?? "",
        "Company Description": item?.company_description ?? "",
        Status: statusObj ? statusObj.title : "",
        "Created At": item?.created_at
          ? moment(item.created_at).format("DD-MMM-YYYY hh:mm A")
          : "",
      };
    });

    const workSheet = XLSX.utils.json_to_sheet(exportData);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Vendors");
    XLSX.writeFile(workBook, "Vendors.xlsx");
  };

  useEffect(() => {
    handleAdviserList();
  }, []);

  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <b>Vendors</b>
          </h5>
          <div className="d-flex gap-2">
            {data?.length !== 0 && adminType !== 2 && (
              <button
                className="btn btn-primary btn-sm search-style border-0 text-white rounded"
                onClick={handleBulkEmail}
              >
                Bulk Email
              </button>
            )}
            {data?.length !== 0 && (
              <button
                className="btn btn-primary btn-sm search-style border-0 text-white rounded"
                onClick={downloadExcel}
              >
                Download Excel
              </button>
            )}
          </div>
        </div>

        <div className="card-body pt-3">
          <CustomTable
            {...props}
            columns={[
              { title: "Sl No", field: "slno", style: { width: "70px", maxWidth: "70px" } },
              {
                title: "Name",
                field: "name",
              },
              {
                title: "Application Ref No",
                field: "unique_application_ref_no",
              },
              { title: "Contact Number", field: "phone" },
              { title: "Email", field: "email" },
              {
                title: "Status",
                field: "status",
                render: (row) => {
                  const statusInfo = getStatusInfo(row.status);
                  return (
                    <span className={`status-badge ${statusInfo.class}`}>
                      <span className="status-icon">{statusInfo.icon}</span>
                      <span className="status-label">{statusInfo.label}</span>
                    </span>
                  );
                },
              },
              {
                title: "Action",
                render: (row) => (
                  <div className="d-flex gap-1">
                    <button
                      className="btn btn-sm btn-outline-primary action-btn"
                      onClick={() => handleView(row)}
                      title="View"
                    >
                      <FiEye size={16} />
                    </button>
                    {adminType === 2 && (
                      <button
                        className="btn btn-sm btn-outline-danger action-btn"
                        onClick={() => handleDelete(row)}
                        title="Delete"
                      >
                        <FiTrash2 size={16} />
                      </button>
                    )}
                  </div>
                ),
              },
            ]}
            data={data}
            handleDownload={handleDownload}
            handleDownload2={handleDownloadReceipt}
          />
        </div>
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Vendor ?"
          data={activeData}
          message="Are you sure to delete this Vendor?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
